module.exports = __webpack_public_path__ + "static/media/map-marked-alt.3cd6ebf5.svg";